<template>
  <div class="main-table" :class="{ isTableScorll: tableScroll }">
    <div class="main-table-tabs" v-if="this.$slots['tableTabs']">
      <slot name="tableTabs"></slot>
    </div>
    <div class="main-table-body" :class="{ boxShadow: boxShadow }">
      <a-spin tip="努力加载..." :spinning="loading">
        <TableSearch
          v-if="search"
          :searchData="searchColumns"
          @searchBack="searchBack"
          @searchChange="searchChange"
        />
        <div class="main-list-info clearfix" v-if="this.$slots['tableInfo']">
          <slot name="tableInfo"></slot>
        </div>
        <!-- {{ this.newColumns }} -->
        <a-table
          :columns="newColumns"
          bordered
          :data-source="dataSource"
          :title="getTableTitle"
          :scroll="
            Object.assign(
              {},
              scroll.x ? { x: scroll.x } : {},
              tableScroll ? { y: 3000 } : scroll.y ? { y: scroll.y } : {}
            )
          "
          :rowKey="rowKey"
          class="main-ant-table-nav"
          :locale="locale"
          :pagination="false"
          :row-selection="rowSelection"
          @change="changeTable"
        >
          <template #headerTitle></template>
          <template #tableTitle></template>
          <template
            :slot="item.dataIndex"
            v-for="item in newColumns"
            slot-scope="text, record, index"
          >
            <slot
              :name="item.dataIndex"
              v-bind="{ text, record, index }"
            ></slot>
          </template>
        </a-table>
        <div
          class="main-table-pagination"
          v-if="pagination && dataSource.length"
        >
          <TablePages
            :current="pagination.current"
            :pageSize="pagination.pageSize"
            :total="pagination.total"
            @changePage="changePage"
          />
        </div>
      </a-spin>
    </div>
  </div>
</template>
<script>
/*
    <pub-table
      :columns="columns"
      :dataSource="data"
      :pagination="pagination"
      :loading="loading"
      :tableWidth="tableScroll"
      @changePage="changePage"
      :isCheck="true" // 是否有checkbox，默认无
      @checkData="changCheck" // 有checkbox时选择时的返回
    >
    </pub-table>
*/
import TableSearch from "./../TableSearch";
import TableHeader from "./TableHeader";
import TablePages from "./TablePages";
import PubEmpty from "@/components/Public/PubEmpty";
export default {
  components: {
    TableSearch,
    TablePages,
  },
  name: "PubTable",
  props: {
    rowKey: {
      type: String || Function,
      default: "id",
    },
    columns: {
      type: Array,
      default: () => [],
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    tableScroll: {
      // table 纵向是否需要自动高度  默认表格高度跟随 整个页面的剩余部分
      type: Boolean,
      default: false,
    },
    // 是否显示搜索，默认显示
    search: {
      type: Boolean,
      default: true,
    },
    // 是否显示表格右侧的快捷操作，默认不显示
    tableOptions: {
      type: Boolean,
      default: false,
    },
    scroll: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    // 是否显示边框阴影，默认不显示
    boxShadow: {
      type: Boolean,
      default: false,
    },
    // 可选择列 已选择的ID
    rowSelection: {
      type: Object,
      default: null,
    },
    pagination: {
      type: Object || Boolean,
      default: () => ({
        current: 1,
        pageSize: 20,
        total: 0,
      }),
    },
  },
  computed: {
    // 表格的展示项
    newColumns: function() {
      // console.log(8888)
      // console.log(this.columns)
      return this.columns && this.columns.length
        ? this.columns
            .filter(v => !v.hideInTable)
            .map(k => ({
              ...k,
              scopedSlots: k.scopedSlots
                ? { customRender: k.dataIndex }
                : false,
            }))
        : [];
    },
    // 搜索的对象
    searchColumns: function() {
      // console.log(99999)
      // console.log(this.columns.filter(v => !v.hideInSearch));
      return this.columns.length
        ? this.columns.filter(v => !v.hideInSearch)
        : [];
    },
  },
  data() {
    return {
      checkedList: [],
      checkAll: false,
      // table为空时的自定义
      locale: {
        emptyText: <PubEmpty />,
      },
    };
  },
  mounted() {
    // console.log(this.$slots);
    // console.log(Object.keys(this.$slots));
  },
  methods: {
    getTableTitle() {
      // console.log(this.$scopedSlots);
      const tableTitle = this.$scopedSlots.tableTitle
        ? this.$scopedSlots.tableTitle()
        : null;
      const tableButton = this.$scopedSlots.tableButton
        ? this.$scopedSlots.tableButton()
        : null;
      return (
        <TableHeader
          showTableTitle={!!tableTitle}
          showTableButton={!!tableButton}
          showTableOptions={this.tableOptions}
        >
          <template slot="tableTitle">{tableTitle}</template>
          <template slot="tableButton">{tableButton}</template>
        </TableHeader>
      );
    },
    // 搜索回调
    searchBack(data) {
      console.log("搜索", data);
      this.$emit("searchBack", data);
    },
    // 搜索改变时
    searchChange(data) {
      console.log("搜索改变时", data);
      // this.$emit("searchChange", data);
    },

    // 改变回调
    changeTable(data) {
      const backData = {
        type: "page",
        data: {
          current: data.current,
          pageSize: data.pageSize,
        },
      };
      console.log("改变", backData);
    },
    // 列表里的checkbox选择
    onChange(e) {
      if (e.target.checked) {
        this.checkedList.push(e.target.id);
      } else {
        this.checkedList.splice(this.checkedList.indexOf(e.target.id), 1);
      }
      this.checkAll = this.checkedList.length === this.dataSource.length;
      this.checkTrBg();
    },
    // 全选的checkbox选择
    onCheckAllChange(e) {
      this.checkAll = e.target.checked;
      if (e.target.checked) {
        this.checkedList = [];
        for (let i in this.dataSource) {
          this.checkedList.push(i + "");
        }
      } else {
        this.checkedList = [];
      }
      this.checkTrBg();
    },
    // 选择checkbox时返回
    checkTrBg() {
      this.$emit("checkData", this.checkedList);
    },

    // 翻页
    changePage(data) {
      // console.log("翻页", data);
      this.$emit("pagesChange", data);
    },
  },
  // watch: {
  //   clearCheck: {
  //     handler: function (newVal) {
  //       if (newVal) {
  //         this.checkedList = [];
  //         this.checkAll = false;
  //         this.$emit("checkData", this.checkedList);
  //       }
  //     },
  //   },
  // },
};
</script>

<style lang="less">
@import "./style.less";
</style>
